import React from 'react';

import { FacebookRegularIcon, InstagramIcon, RedditIcon } from '@change/ds-icons';

import { Chip, SocialIcon } from '@change/ds-core-ui/next';

import type { PlatformType } from '../../utils/platformGrouping';
import { PLATFORM_LABELS } from '../../utils/platformGrouping';

type Props = {
	selectedPlatform: PlatformType | undefined;
	onClearSelection: () => void;
	onPlatformSelect: (platform: PlatformType) => void;
	availablePlatforms: PlatformType[];
};

type IconMap = {
	iconComponent: React.ComponentType<{ svgClassName?: string }>;
	iconVariant: React.ComponentProps<typeof SocialIcon>['variant'];
};

const PLATFORM_ICONS: Record<PlatformType, IconMap> = {
	facebook: {
		iconComponent: FacebookRegularIcon,
		iconVariant: 'facebook',
	},
	reddit: {
		iconComponent: RedditIcon,
		iconVariant: 'reddit',
	},
	instagram: {
		iconComponent: InstagramIcon,
		iconVariant: 'instagram',
	},
	facebookgroups: {
		iconComponent: FacebookRegularIcon,
		iconVariant: 'facebook',
	},
};

export function PlatformFilter(props: Props) {
	const { selectedPlatform, onClearSelection, onPlatformSelect, availablePlatforms } = props;

	return (
		<div className="mb-6 flex w-full flex-row items-center justify-between gap-4" data-testid="chips-and-scroll-row">
			{/* Chips Container */}
			<div className="flex flex-grow gap-2" data-testid="platform-chips-container">
				{/* "All" Chip */}
				<div className="flex flex-grow gap-2">
					<Chip
						data-active={!selectedPlatform}
						active={!selectedPlatform}
						onClick={onClearSelection}
						size="small"
						data-testid="platform-chip-all"
					>
						All
					</Chip>

					{/* Platform Chips */}
					{availablePlatforms.map((platform) => {
						const iconData = PLATFORM_ICONS[platform];
						return (
							<Chip
								key={platform}
								className="text-white"
								data-active={selectedPlatform === platform}
								active={selectedPlatform === platform}
								onClick={() => onPlatformSelect(platform)}
								size="small"
								leadingIcon={
									<SocialIcon
										size="small"
										icon={<iconData.iconComponent svgClassName="!text-white" />}
										variant={iconData.iconVariant}
									/>
								}
								data-testid={`platform-chip-${platform}`}
							>
								{PLATFORM_LABELS[platform]}
							</Chip>
						);
					})}
				</div>
			</div>
		</div>
	);
}
